import script from "./index_ref.vue?vue&type=script&setup=true&lang=ts"
export * from "./index_ref.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__